import { z } from 'zod';

export const addressSchema = z.object({
    label: z.string().min(1, 'La etiqueta es obligatoria (ej: Casa, Trabajo)'),
    street: z.string().min(1, 'La calle es obligatoria'),
    number: z.string().min(1, 'La altura es obligatoria'),
    floor: z.string().optional(),
    apartment: z.string().optional(),
    district: z.string().min(1, 'El barrio es obligatorio'),
    city: z.string().min(1, 'La ciudad es obligatoria'),
    reference: z.string().optional(),
    is_default: z.boolean().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
});

export type AddressFormValues = z.infer<typeof addressSchema>;
